import { appServiceClient } from '@/infrastructure/http/httpClient';

import {
  IArquivoParaOVesto,
  IExportacaoVestoConfig,
  IExportacaoVestoResumo,
  IExportarParaVestoPayload,
  IPendenciaDoVesto,
} from '../interfaces/exportacaoVesto';

/**
 * A devolução das datas para o VESTO. Repositório PRÓPRIO e não um bloco no fim do
 * `opsRepository`: são quatro rotas de um assunto só, e o arquivo da carteira já é grande.
 */
class ExportacaoVestoRepository {
  /** As últimas exportações: a lista do bloco de Configurações. */
  async list(): Promise<Array<IExportacaoVestoResumo>> {
    return appServiceClient.get<Array<IExportacaoVestoResumo>>('ops/exportacoes-vesto');
  }

  async configuracao(): Promise<IExportacaoVestoConfig> {
    return appServiceClient.get<IExportacaoVestoConfig>('ops/exportacoes-vesto/configuracao');
  }

  /** Quantas OPs estão com data diferente da que foi: o número do aviso. */
  async pendencia(): Promise<IPendenciaDoVesto> {
    return appServiceClient.get<IPendenciaDoVesto>('ops/exportacoes-vesto/pendencia');
  }

  /**
   * Gera o arquivo e REGISTRA que ele saiu, na mesma chamada. A resposta traz o conteúdo
   * para o navegador salvar: é o servidor que monta o CSV, para as colunas e o separador
   * terem uma fonte só.
   */
  async exportar(payload: IExportarParaVestoPayload): Promise<IArquivoParaOVesto> {
    return appServiceClient.post<IArquivoParaOVesto>('ops/exportacoes-vesto', { body: payload });
  }
}

export const exportacaoVestoRepository = new ExportacaoVestoRepository();
